import React from 'react'
import { styled } from '@mui/material'

const StyledHeaderDiv = styled('div')(() => ({
  fontWeight: 'bold',
  color: 'black',
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  lineHeight: '1.2',
  textAlign: 'left',
}))

interface StyledHeaderTextProps {
  testId: string
  headerName?: string
}

export function StyledHeaderText({ testId, headerName }: StyledHeaderTextProps) {
  return <StyledHeaderDiv data-testid={testId}>{headerName}</StyledHeaderDiv>
}
